import useSWR from 'swr'
import { ConversationService } from '@forwardflow/services/ConversationService'
import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'

export const useGetRecordingPresignedUrl = (objKey?: string) => {
   const fetcher = objKey ? () => ConversationService.getRecordingPresignedUrl(objKey) : null
   
   const { data, error, mutate, isValidating } = useSWR(
      objKey ? [QUERY_KEYS.GET_RECORDING_PRESIGNED_URL, objKey] : null,
      objKey ? fetcher : null
   )

   return {
      data: data as any,
      loading: isValidating,
      error: error?.message || null,
      mutate,
   }
}
